import { useSelector } from 'react-redux';
import get from 'lodash/get';

/**
 * Whether product creation is closed (LAU-141). Payout-only mode is a superset
 * and implies it, matching Shared::CreationDisabled on the Rails side.
 *
 * Used by the create call-to-action and empty states scattered through the app
 * — store editor, integrations, product picker — which sit too deep to thread
 * the flag down to.
 */
export const useCreationDisabled = () =>
  useSelector(
    (state) =>
      Boolean(get(state, 'header.user.payoutOnlyMode', false)) ||
      Boolean(get(state, 'header.user.creationDisabled', false))
  );

export default useCreationDisabled;
